import { render, staticRenderFns } from "./ApplicantShowDashboard.vue?vue&type=template&id=5882f698&"
import script from "./ApplicantShowDashboard.vue?vue&type=script&lang=js&"
export * from "./ApplicantShowDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports